module.exports = __webpack_public_path__ + "static/media/SMSServices.a6caf3e2.svg";